<template>
  <div class="">
    <div class="row justify-content-end">
      <div class="col-auto">
        <button @click="refresh()" class="btn btn-secondary">
          <i class="bi bi-arrow-clockwise"></i>
          Actualiser
        </button>
      </div>

      <div class="col-auto">
        <button
          @click="$router.push({ name: 'items-create' })"
          class="btn btn-primary"
        >
          <i class="bi bi-plus-square"></i>
          Créer un nouveau produit
        </button>
      </div>

      <div class="col-auto">
        <button @click="printAll()" class="btn btn-secondary">
          <i class="bi bi-printer"></i>
          Imprimer
        </button>
      </div>
    </div>
    <br />

    <vue-data-table
      :headers="headers"
      :data="items"
      :items-per-page="10"
      :buttons="buttons"
      :summable-columns="summableColumns"
    >
      <template #cell-image="{ row }">
        <div
          class="d-flex justify-content-center align-items-center"
          style="min-height: 60px"
        >
          <img
            :src="$imageUrl(row.image)"
            :alt="row.fullName || 'Item image'"
            class="item-image-thumbnail"
            @error="handleImageError"
          />
        </div>
      </template>
    </vue-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      search_value: "",
      addedToday: false,
      sortValue: "",
      headers: [
        { field: "image", label: "Image", class: "text-center" },
        { field: "reference", label: "Référence", class: "" },
        { field: "fullName", label: "Désignation", class: "" },
        { field: "fullName", label: "Catégorie", class: "" },
        { field: "measuring", label: "Unité", class: "" },
        { field: "pcs", label: "Sacs", class: "" },
        { field: "priceTTC", label: "Prix TTC", class: "" },
        { field: "tva", label: "TVA", class: "" },
      ],
      buttons: [
        {
          label: "Edit",
          icon: "bi bi-pencil-square",
          class: "btn",
          visible: () => this.$userRole === "Admin",
          action: (item) => {
            this.$router.push({
              name: "items-edit",
              params: { reference: item.reference },
            });
          },
        },
        {
          label: "Details",
          icon: "bi bi-list-ul text-primary",
          class: "btn",
          action: (item) => {
            this.$router.push({
              name: "items-details",
              params: { reference: item.reference },
            });
          },
        },
        {
          label: "Delete",
          icon: "bi bi-trash text-danger",
          class: "btn",
          visible: () => this.$userRole === "Admin",
          action: (item) => {
            this.remove(item);
          },
        },
      ],
      summableColumns: [],
    };
  },
  computed: {
    ...mapGetters("item", {
      items: "getItems",
    }),
    // imageUrl() {
    //   return (item) => `${item.image}`
    // },
  },
  mounted() {
    this.$store.dispatch("item/getAll");
  },
  methods: {
    async search(value) {
      return await this.$store.commit("item/search", value);
    },
    async refresh() {
      return await this.$store.dispatch("item/getAll");
    },

    async sort(value) {
      return await this.$store.commit("item/sort", value);
    },

    async remove(data) {
      let item = data;
      try {
        const confirmed = await this.$confirm({
          title: "Supprimer l'article",
          message: "Vous voulez supprimer l'article " + item.fullName + " ?",
          confirmButtonText: "Oui",
          cancelButtonText: "Non",
        });

        if (confirmed) {
          await this.$store.dispatch("item/destroy", item.reference);
          // Refresh the list after successful deletion
          await this.refresh();
        }
      } catch (error) {
        console.error("Error deleting item:", error);
        // Error is already handled by the store/API, just log it
      }
    },

    async printAll() {
      return await this.$store.dispatch("item/printAll");
    },

    handleImageError(event) {
      // If image fails to load, show placeholder icon
      event.target.style.display = "none";
      const placeholder =
        event.target.parentElement.querySelector(".image-placeholder");
      if (!placeholder) {
        const placeholderDiv = document.createElement("div");
        placeholderDiv.className =
          "image-placeholder text-muted d-flex align-items-center justify-content-center";
        placeholderDiv.innerHTML =
          '<i class="bi bi-image" style="font-size: 1.5rem;"></i>';
        event.target.parentElement.appendChild(placeholderDiv);
      }
    },
  },
};
</script>

<style scoped>
.item-image-thumbnail {
  max-width: 60px;
  max-height: 60px;
  width: auto;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
  border: 2px solid #e2e8f0;
  padding: 2px;
  background: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease;
}

.item-image-thumbnail:hover {
  transform: scale(1.1);
  border-color: #667eea;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.image-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 2px dashed #dee2e6;
}
</style>
